import { useState, useEffect } from 'react';
import { Box, Flex, SystemProps } from '@storyofams/react-ui';
import { Texture1, Texture2, Texture3, Texture4, Texture5 } from '~components/common/ProductItem/Textures';
import { FixedRatio, Heading, Text } from '~components';
import { Image as StoryblokImage } from '@storyofams/storyblok-toolkit';

export const ThemeBoxProduct = ({
  title,
  description,
  image,
  textBlockBackgroundColor,
  backgroundColor,
  fontColor,
  textureType,
  smallText,
  MoreInfoButton,
}) => {

  const Texture = () => {
    const texture = textureType ||  '1'

    switch (texture) {
      case '1': {
        return <Texture1
          textureColor={textBlockBackgroundColor}
          backgroundColor={backgroundColor}
        />
      }
      case '2': {
        return <Texture2
          textureColor={textBlockBackgroundColor}
          backgroundColor={backgroundColor}
        />
      }
      case '3': {
        return <Texture3
          textureColor={textBlockBackgroundColor}
          backgroundColor={backgroundColor}
        />
      }
      case '4': {
        return <Texture4
          textureColor={textBlockBackgroundColor}
          backgroundColor={backgroundColor}
        />
      }
      case '5': {
        return <Texture5
          textureColor={textBlockBackgroundColor}
          backgroundColor={backgroundColor}
        />
      }
      default: {
        return <Texture1
          textureColor={textBlockBackgroundColor}
          backgroundColor={backgroundColor}
        />
      }
    }
  }

  return (
    <Flex
      width={'100%'}
      flexDirection={'column'}
      minWidth={'200px'}
    >
      {!!image && (
        <Box bg={backgroundColor} width={'100%'}>
          <Box
            width={'100%'}
            mx={'auto'}
            my={1}
          >
            <FixedRatio
              ratio={[[1, 1]]}
              overflow="hidden"
            >
              <StoryblokImage
                width="100%"
                src={image.filename}
                alt={image.alt}
              />
            </FixedRatio>
          </Box>
        </Box>
      )}
      <Box>
        <FixedRatio
            ratio={[[300, 42]]}
            overflow="hidden"
          >
          <FixedRatio
            ratio={[[300, 64]]}
            overflow="hidden"
          >
            <Texture />
          </FixedRatio>
        </FixedRatio>
      </Box>
      <Box
        height={'100%'}
        bg={textBlockBackgroundColor}
      >
        <Flex
          pt={[2]}
          pb={[4]}
          px={[3]}
          flexDirection={'column'}
          height={'100%'}
          justifyContent={'space-between'}
        >
          <Box>
            <Heading
              as="h2"
              variant="sh2"
              width={'100%'}
              color={fontColor}
              style={{
                overflowWrap: 'anywhere'
              }}
              fontSize={smallText ? ['24px', '24px'] : []}
            >
              {title}
            </Heading>
            <Text
              mt={1}
              color={fontColor}
              lineHeight={'130%'}
              fontSize={smallText ? '16px' : '20px'}
            >
              {description}
            </Text>
          </Box>
          {!!MoreInfoButton && (
            <Box mt={2}>
              <MoreInfoButton />
            </Box>
          )}
        </Flex>
      </Box>
    </Flex>
  );
};
